import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import Layout from "../../components/layout/V2/Layout";
// import AdCampaignsTab from "../../components/V2/AdCampaignsTab";
import OffersTab from "../../components/V2/OffersTab";
import CouponsTab from "../../components/coupon/CouponsTab";

export default function PromotionsPage() {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("offers");
  const [showShareDialogue, setShowShareDialogue] = useState(false);
  const [operation, setOperation] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const tab = params.get("tab") || "offers";

    setActiveTab(tab);
  }, [location]);

  const showDialogueHandler = (bool, type) => {
    setShowShareDialogue(bool);
    setOperation(type);
  };
  return (
    <Layout
      headerTitle="Promotions"
      showDialogueHandler={showDialogueHandler}
      operation={operation}
      show={showShareDialogue}
    >
      <div className="relative overflow-y-auto min-h-screen scroll-smooth pt-[60px] pb-[120px] w-full md:max-w-screen-lg container mx-auto flex flex-col">
        <ul
          className="nav nav-tabs secondary nav-justified flex flex-row list-none border-b-0 pl-0 w-full md:max-w-screen-lg"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li
            className="nav-item flex-grow text-center w-full md:max-w-screen-lg"
            role="presentation"
          >
            <a
              href="#offers-tab"
              className={`nav-link text-center w-full block font-bold text-sm leading-tight border-x-0 border-t-0 border-b-2 border-transparent px-6 py-5 hover:border-transparent hover:bg-gray-100 focus:border-transparent ${
                activeTab === "offers" ? "active" : ""
              }`}
              id="tabs-profile-tabJustify"
              data-bs-toggle="pill"
              data-bs-target="#offers-tab"
              role="tab"
              aria-controls="offers-tab"
              aria-selected={activeTab === "offers"}
            >
              Text Marketing
            </a>
          </li>
          <li className="nav-item flex-grow text-start" role="presentation">
            <a
              href="#coupons"
              className={`nav-link text-center w-full block font-bold text-sm leading-tight border-x-0 border-t-0 border-b-2 border-transparent px-6 py-5 hover:border-transparent hover:bg-gray-100 focus:border-transparent ${
                activeTab === "coupons" ? "active" : ""
              }`}
              id="tabs-home-tabJustify"
              data-bs-toggle="pill"
              data-bs-target="#coupons"
              role="tab"
              aria-controls="coupons"
              aria-selected={activeTab === "coupons"}
            >
              Online Offers
            </a>
          </li>
        </ul>
        <div
          className="tab-content flex-grow flex h-full "
          id="tabs-tabContentJustify"
        >
          <div
            className={`tab-pane fade mx-auto w-full md:max-w-screen-lg ${
              activeTab === "offers" ? " show active" : ""
            }`}
            id="offers-tab"
            role="tabpanel"
            aria-labelledby="tabs-offers-tabJustify"
          >
            <OffersTab />
          </div>
          <div
            className={`tab-pane fade mx-auto w-full ${
              activeTab === "coupons" ? " show active" : ""
            } w-full`}
            id="coupons"
            role="tabpanel"
            aria-labelledby="tabs-home-tabJustify"
          >
            <CouponsTab />
          </div>
        </div>
      </div>
    </Layout>
  );
}
